module.exports = __webpack_public_path__ + "static/media/artwork_13.98ad1d0c.jpg";